import { ITag } from '@sdk/contracts';
import { Popover, Tag } from 'antd';
import { CSSProperties } from 'react';
import { v4 as key } from 'uuid';

import { Wrapper } from './Tags.styles';

type Props = {
  tags: ITag[];
  direction?: CSSProperties['flexDirection'];
};

export const Tags: React.FC<Props> = ({ tags, direction }) => {
  const TAGS = tags.map(tag => <Tag key={tag?._id}>{tag?.name}</Tag>);

  return (
    <Popover content={TAGS}>
      <Wrapper key={key()} direction={direction}>
        {TAGS}
      </Wrapper>
    </Popover>
  );
};
